<div [ngClass]="'note--' + type()" class="note" role="alert">
  <mat-icon class="note__icon">{{ icon() }}</mat-icon>
  <div [innerHTML]="messageText()"></div>
</div>
